import PerfectScrollbar from "perfect-scrollbar";
import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

function Sidebar() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [showIncomeMenu, setshowIncomeMenu] = useState(false);
  useEffect(() => {
    new PerfectScrollbar(".multinav-scroll");
  }, []);
  return (
    <aside className="main-sidebar">
      <section className="sidebar position-relative">
        <div className="multinav">
          <div className="multinav-scroll" style={{ height: "97%" }}>
            <ul className="sidebar-menu" data-widget="tree">
              <li className="header fs-10 m-0 text-uppercase">Dashboard</li>
              <li
                className={`treeview ${pathname === "/home" ? "active" : ""}`}
              >
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    document.body.classList.remove("sidebar-open");
                    navigate("/home");
                  }}
                >
                  <i data-feather="home"></i>
                  <span>Dashboard</span>
                </a>
                <ul class="treeview-menu">
                  <li>
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        document.body.classList.remove("sidebar-open");
                        navigate("/home");
                      }}
                    >
                      <i data-feather="git-commit"></i> Dashboard
                    </a>
                  </li>
                </ul>
              </li>

              <li className={`treeview`}>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    window.open("https://happiedealz.com/#/token/" + localStorage.getItem('token'), "_blank")
                  }}
                >
                  <i data-feather="box"></i>
                  <span>B2B</span>
                </a>
                <ul class="treeview-menu">
                  <li>
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        window.open("https://happiedealz.com/#/token/" + localStorage.getItem('token'), "_blank")
                      }}
                    >
                      <i data-feather="git-commit"></i> B2B
                    </a>
                  </li>
                </ul>
              </li>
              <li
                className={`treeview ${pathname === "/directsponsor" ? "active" : ""
                  }`}
              >
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    document.body.classList.remove("sidebar-open");
                    navigate("/directsponsor");
                  }}
                >
                  <i data-feather="user"></i>
                  <span>Direct Team List</span>
                </a>
                <ul class="treeview-menu">
                  <li>
                    <a
                      onClick={(e) => {
                        e.preventDefault();
                        document.body.classList.remove("sidebar-open");
                        navigate("/directsponsor");
                      }}
                    >
                      <i data-feather="git-commit"></i> Direct Sponsor List
                    </a>
                  </li>
                </ul>
              </li>
              <li
                className={`treeview ${pathname === "/teamlist" ? "active" : ""
                  }`}
              >
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    document.body.classList.remove("sidebar-open");
                    navigate("/teamlist");
                  }}
                >
                  <i data-feather="users"></i>
                  <span>Level Team</span>
                </a>
                <ul class="treeview-menu">
                  <li>
                    <a
                      onClick={(e) => {
                        e.preventDefault();
                        document.body.classList.remove("sidebar-open");
                        navigate("/teamlist");
                      }}
                    >
                      <i data-feather="git-commit"></i> Level Team
                    </a>
                  </li>
                </ul>
              </li>
              <li
                className={`treeview ${pathname === "/treeview" ? "active" : ""
                  }`}
              >
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    document.body.classList.remove("sidebar-open");
                    navigate("/treeview");
                  }}
                >
                  <i data-feather="trello"></i>
                  <span>Sponsor Tree</span>
                </a>
              </li>
              {/* <li
                className={`treeview ${
                  pathname === "/vtreeview" ? "active" : ""
                }`}
              >
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    document.body.classList.remove("sidebar-open");
                    navigate("/vtreeview");
                  }}
                >
                  <i data-feather="trello"></i>
                  <span>Treeview - Vertical</span>
                </a>
              </li> */}
              <li
                className={`treeview ${pathname === "/income/work" ? "active" : ""
                  }`}
              >
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setshowIncomeMenu(!showIncomeMenu);
                  }}
                >
                  <i data-feather="gift"></i>
                  <span>Income</span>
                </a>
                <ul
                  class="treeview-menu"
                  style={{ display: showIncomeMenu ? "block" : "none" }}
                >
                  <li>
                    <a
                      onClick={(e) => {
                        e.preventDefault();
                        document.body.classList.remove("sidebar-open");
                        navigate("/income/directincentive");
                      }}
                    >
                      <i data-feather="git-commit"></i>Direct Incentive
                    </a>
                  </li>
                  <li>
                    <a
                      onClick={(e) => {
                        e.preventDefault();
                        document.body.classList.remove("sidebar-open");
                        navigate("/income/teamincentive");
                      }}
                    >
                      <i data-feather="git-commit"></i>Team Incentive
                    </a>
                  </li>
                  <li>
                    <a
                      onClick={(e) => {
                        e.preventDefault();
                        document.body.classList.remove("sidebar-open");
                        navigate("/income/team");
                      }}
                    >
                      <i data-feather="git-commit"></i>Team Bonus
                    </a>
                  </li>
                  <li>
                    <a
                      onClick={(e) => {
                        e.preventDefault();
                        document.body.classList.remove("sidebar-open");
                        navigate("/income/global");
                      }}
                    >
                      <i data-feather="git-commit"></i>Global Bonus
                    </a>
                  </li>
                  <li>
                    <a
                      onClick={(e) => {
                        e.preventDefault();
                        document.body.classList.remove("sidebar-open");
                        navigate("/income/royalty");
                      }}
                    >
                      <i data-feather="git-commit"></i>Royalty Bonus
                    </a>
                  </li>
                </ul>
              </li>
              <li
                className={`treeview ${pathname === "/passbook" ? "active" : ""
                  }`}
              >
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    document.body.classList.remove("sidebar-open");
                    navigate("/passbook");
                  }}
                >
                  <i data-feather="calendar"></i>
                  <span>Passbook</span>
                </a>
                <ul class="treeview-menu">
                  <li>
                    <a
                      onClick={(e) => {
                        e.preventDefault();
                        document.body.classList.remove("sidebar-open");
                        navigate("/passbook");
                      }}
                    >
                      <i data-feather="git-commit"></i> Passbook
                    </a>
                  </li>
                </ul>
              </li>
              {/* <li
                className={`treeview ${
                  pathname === "/documentbank" ? "active" : ""
                }`}
              >
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    document.body.classList.remove("sidebar-open");
                    navigate("/documentbank");
                  }}
                >
                  <i data-feather="help-circle"></i>
                  <span>Document Bank</span>
                </a>
              </li> */}
              <li
                className={`treeview ${pathname === "/faq" ? "active" : ""
                  }`}
              >
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    document.body.classList.remove("sidebar-open");
                    navigate("/faq");
                  }}
                >
                  <i data-feather="help-circle"></i>
                  <span>FAQ</span>
                </a>
              </li>
              <li
                className={`treeview`}
              >
                <a
                  href="/office/staticpages/Happie-Marketing-Business-Plan.pdf"
                  target="_blank"
                >
                  <i data-feather="file"></i>
                  <span>BUSINESS PLAN</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </section>
    </aside>
  );
}

export default Sidebar;
